import { render } from "./s3.vue?vue&type=template&id=4893ad4d"
import script from "./s3.vue?vue&type=script&lang=js"
export * from "./s3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__